import { render, staticRenderFns } from "./RomaWyswyg.vue?vue&type=template&id=26130328&"
import script from "./RomaWyswyg.vue?vue&type=script&lang=js&"
export * from "./RomaWyswyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports